export const PolicyType = {
  CompanyCharge: "company_charge",
  ZealFee: "zeal_fee",
} as const;
export type PolicyType = (typeof PolicyType)[keyof typeof PolicyType];
